// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import WidgetSearchReservationRequestViewModel from '../../viewModel/resource/WidgetSearchReservationRequestViewModel';
import WidgetReservationListResourcePagingResultViewModel from '../../viewModel/resource/WidgetReservationListResourcePagingResultViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getWidgetReservations(model: WidgetSearchReservationRequestViewModel, config?: RequestConfig) {
    const modelDTO = model.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-reservations'] ?? 'WidgetReservations';
    const response = await service.post<any>(endpointPath, {
      body: modelDTO,
      ...config,
    });
    const dto = response.data.result;
    return new WidgetReservationListResourcePagingResultViewModel().fromDTO(dto);
  },
});
